import { ScormStatusMode } from 'gql/__generated__/graphql'
import type { ScormSettings } from 'services/Store/Project/types'

export const getTestStatuses = (
  score: { percent: number },
  scormSettings: ScormSettings,
  params: { canRetryTest: boolean; testThreshold?: number | null },
) => {
  const isPassed = score.percent >= (params.testThreshold || 0)
  let successStatus: 'unknown' | 'failed' | 'passed' = 'unknown'
  let completionStatus: 'incomplete' | 'completed' = 'incomplete'
  if (!isPassed && params.canRetryTest) {
    return {
      successStatus,
      completionStatus,
    }
  }

  if (scormSettings.runtimeSettings?.usedStatuses === ScormStatusMode.passedFailed) {
    successStatus = isPassed ? 'passed' : 'failed'
    completionStatus = 'completed'
  } else if (scormSettings.runtimeSettings?.usedStatuses === ScormStatusMode.completeFailed) {
    if (isPassed) {
      completionStatus = 'completed'
    } else {
      successStatus = 'failed'
    }
  } else if (scormSettings.runtimeSettings?.usedStatuses === ScormStatusMode.completeIncomplete) {
    completionStatus = isPassed ? 'completed' : 'incomplete'
  } else if (scormSettings.runtimeSettings?.usedStatuses === ScormStatusMode.passedIncomplete) {
    if (isPassed) {
      successStatus = 'passed'
      completionStatus = 'completed'
    }
  }

  return {
    successStatus,
    completionStatus,
  }
}
